import { useEffect, useRef } from "react";

import { ChevronRightIcon } from "@chakra-ui/icons";
import { Link } from "@chakra-ui/next-js";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbProps, Skeleton } from "@chakra-ui/react";

import { BreadcrumbData, useBreadcrumbs } from "@/providers/useBreadcrumbs";

const defaultProps = {
  omitIndexList: [],
};

function AppBreadcrumbs({
  omitIndexList,
  ...props
}: {
  omitIndexList?: ReadonlyArray<number>;
} & BreadcrumbProps) {
  const breadcrumbRef = useRef<HTMLLIElement>(null);

  const { breadcrumbs } = useBreadcrumbs();

  const filteredBreadcrumbs = breadcrumbs.filter((breadcrumb: BreadcrumbData, i: number) => {
    return !(!breadcrumb || (omitIndexList && omitIndexList.includes(i)));
  });

  useEffect(() => {
    breadcrumbRef?.current?.scrollIntoView(true);
  }, [breadcrumbs]);

  return (
    <Breadcrumb separator={<ChevronRightIcon color="gray.500" />} {...props}>
      {filteredBreadcrumbs.length >= 1 &&
        filteredBreadcrumbs.map((breadcrumb: BreadcrumbData, i: number) => {
          const breadcrumbItemProps = filteredBreadcrumbs[i + 1]
            ? { color: "text.darker" }
            : { isCurrentPage: true, ref: breadcrumbRef };
          const asLink = filteredBreadcrumbs[i + 1]
            ? { as: Link, href: breadcrumb.href }
            : { href: breadcrumb.href };

          return (
            <BreadcrumbItem key={breadcrumb.href} whiteSpace="nowrap" {...breadcrumbItemProps}>
              {breadcrumb.breadcrumb ? (
                <BreadcrumbLink {...asLink}>{breadcrumb.breadcrumb}</BreadcrumbLink>
              ) : (
                <Skeleton height={5} width={14} />
              )}
            </BreadcrumbItem>
          );
        })}
    </Breadcrumb>
  );
}

AppBreadcrumbs.defaultProps = defaultProps;

export default AppBreadcrumbs;
